import React from "react";
import { Card, Typography, Space, Avatar, Tag } from "antd";
import { CrownOutlined, StarOutlined, UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const LeaderboardRow = ({
  name,
  // role,
  // points,
  // badges,
  rewardType,
  amount,
  rank,
  topPerformer,
  // tags = [],
}) => {
  return (
    <Card
      style={{
        borderRadius: 16,
        marginBottom: 16,
        background: topPerformer ? "#fffbe6" : "#ffffff",
        border: topPerformer ? "1px solid #fadb14" : "1px solid #f0f0f0",
      }}
      bodyStyle={{ padding: 20 }}
    >
      <Space
        style={{ justifyContent: "space-between", width: "100%" }}
        align="start"
      >
        {/* Left Side */}
        <Space align="start">
          <Avatar
            size={48}
            style={{
              background: topPerformer ? "#faad14" : "#f0f0f0",
              color: topPerformer ? "#fff" : "#555",
              fontWeight: 600,
            }}
            icon={!topPerformer && rank > 3 ? <UserOutlined /> : null}
          >
            {topPerformer ? <CrownOutlined /> : rank > 3 ? rank : null}
          </Avatar>

          <Space direction="vertical" size={2}>
            <Space>
              <Text strong style={{ fontSize: 16 }}>
                {name}
              </Text>

              {topPerformer && (
                <Tag color="gold" style={{ borderRadius: 12 }}>
                  Top Performer
                </Tag>
              )}
            </Space>

            {/* <Text type="secondary">{role}</Text> */}
          </Space>
        </Space>

        {/* Right Side */}
                <Space direction="vertical" align="end" size={0}>
          <Space>
            <StarOutlined style={{ color: "#faad14" }} />
            <Text strong style={{ fontSize: 18 }}>
              {amount} {rewardType}
            </Text>
          </Space>
          {/* <Text type="secondary">{badges} badges earned</Text> */}
        </Space>
        {/* <Space direction="vertical" align="end" size={0}>
          <Space>
            <StarOutlined style={{ color: "#faad14" }} />
            <Text strong style={{ fontSize: 18 }}>
              {points}
            </Text>
          </Space>
          <Text type="secondary">{badges} badges earned</Text>
        </Space> */}
      </Space>

      {/* Bottom Tags */}
      {/* {tags.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Space wrap>
            {tags.map((tag, index) => (
              <Tag
                key={index}
                color={tag.color}
                style={{ borderRadius: 12 }}
              >
                {tag.label}
              </Tag>
            ))}
          </Space>
        </div>
      )} */}
    </Card>
  );
};

export default LeaderboardRow;
